import { render, staticRenderFns } from "./AdministratorYourSynchronicity.vue?vue&type=template&id=e32f5fea&"
import script from "./AdministratorYourSynchronicity.vue?vue&type=script&lang=js&"
export * from "./AdministratorYourSynchronicity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports